<template>
  <div>
    <iModal
      title="Add Exhibitor Pass"
      v-model="showModal"
      class-name="vertical-center-modal"
      width="600px"
      :mask-closable="false"
      @on-cancel="cancel"
    >
      <div class="admin-add">
        <div class="admin-add-content">
          <Form
            ref="formInline"
            :model="formInline"
            :rules="ruleInline"
            label-position="right"
            :label-width="170"
          >
            <FormItem label="Exhibitor Pass Type：" :required="true">
              <Select v-model="formInline.BadgeType" :disabled="true">
                <Option v-for="item in typeList" :value="item.value" :key="item.value">{{ item.label }}</Option>
              </Select>
            </FormItem>
            <FormItem label="Company name：" :required="true">
              <Input type="text" v-model="formInline.CompanyName" :disabled="true"></Input>
            </FormItem>
            <!-- <FormItem label="地址：">
              <Input type="text" v-model="formInline.Address" placeholder="请输入地址"></Input>
            </FormItem> -->
            <FormItem label="Name：" prop="FirstName">
              <Input type="text" v-model="formInline.FirstName" placeholder="please enter name"></Input>
            </FormItem>
            <FormItem label="Identity Number：" prop="IdCard">
              <Input type="text" v-model="formInline.IdCard" placeholder="please enter identity number"></Input>
            </FormItem>
            <Checkbox v-model="single" style="margin: 0 0 14px 90px" @on-change="changeCheck">Hong Kong,Macao,Taiwan and Overseas Exhibitor</Checkbox>
            <!-- <FormItem label="部门：">
              <Input type="text" v-model="formInline.Department" placeholder="请输入部门"></Input>
            </FormItem>
            <FormItem label="手机：">
              <Input type="text" v-model="formInline.Mob" placeholder="请输入手机"></Input>
            </FormItem> -->
            <FormItem label="Telephone：" prop="Tel">
              <Input type="text" v-model="formInline.Tel" placeholder="please enter telephone"></Input>
            </FormItem>
            <!-- <FormItem label="传真：">
              <Input type="text" v-model="formInline.Fax" placeholder="请输入传真"></Input>
            </FormItem> -->
            <FormItem label="Email：" prop="Email">
              <Input type="text" v-model="formInline.Email" placeholder="please enter email"></Input>
            </FormItem>
            <FormItem label="Job Title：" prop="JobTitle">
              <Input type="text" v-model="formInline.JobTitle" placeholder="please enter job title"></Input>
            </FormItem>
            <!-- <FormItem label="个人邮箱：">
              <Input type="text" v-model="formInline.PersonalEmail" placeholder="请输入个人邮箱"></Input>
            </FormItem> -->
          </Form>
        </div>
      </div>
      <div slot="footer">
        <Button style="width:180px;" type="primary" :loading="loading" @click="handleSubmit('formInline',0)">Add Extra Exhibitor Pass</Button>
        <Button style="width:90px;" type="primary" :loading="loading2" @click="handleSubmit('formInline',1)">Finish</Button>
        <Button style="width:90px;" type="primary" @click="cancel">Cancel</Button>
      </div>
    </iModal>
  </div>
</template>

<script>
import { validator } from "@/other/validator";
import {  mapGetters, mapActions } from "vuex";

export default {
  name: "addCert",
  props: {
    show: {
      type: Boolean,
      default: false
    },
  },

  data() {
    const viraIdcard = (rule, value, callback) => {
      if(value===''){
        callback(new Error('请输入身份证号'));
      }
              // else if (this.verification1 ==false&&this.check==true) {
              //   callback(new Error('请输入正确的海外证件'));
      // }
      else{
        callback()
      }
    };
    return {
      single:false,
      loading: false,
      loading2: false,
      showModal: false,
      formInline: {
        BadgeType: "Exhibitor Pass",
        CompanyName: "",
        Address: "",
        FirstName: "",
        JobTitle: "",
        Department: "",
        Mob: "",
        Tel: "",
        Fax: "",
        Email: "",
        PersonalEmail: "",
        IdCard: ""
      },
      ruleInline: {
        // 效验规则
        FirstName: [
          {
            required: true,
            message: "please enter name",
            trigger: "blur"
          }
        ], 
        IdCard: [
          {
            required: true,
            message: "please enter identity number",
            trigger: "blur",
            validator:viraIdcard,
          }
        ], 
        Tel: [
          {
            required: true,
            message: "please enter telephone",
            trigger: "blur"
          }
        ],
        Email: [
          {
            required: true,
            message: "please enter email",
            trigger: "blur"
          }
        ],
        JobTitle: [
          {
            required: true,
            message: "please enter job title",
            trigger: "blur"
          }
        ],
        // Mob: validator.phone,
      },
      typeList: [
        {
          value: "Exhibitor Pass",
          label: "Exhibitor Pass",
        }
      ]
    };
  },
  watch: {
    show(val, oldVal) {
      this.showModal = val;
      if (this.company) {
        this.formInline.CompanyName = this.company.name;
      }
      if (!val) this.$emit("close");
    },
  },
  computed: {
    ...mapGetters({
      company: "loginModule/getCompany",  
      exhibition: "loginModule/getExhibition",
      joinInfo:'loginModule/getJoinInfo'
    }),
    exhibitonId() { return this.exhibition.id},
    header() { return this.$store.state.header},
  },
  methods: {
    ...mapActions({
      realAuth: "realAuth"
    }),
    async handleSubmit(name,e) {
      let form = this.formInline;
      let valid = await this.validForm(name);
      if (!valid) return;

      // 实名验证
      if(this.check==false){
        let info = await this.realAuth({
          idcard: this.formInline.IdCard,
          name: this.formInline.FirstName,
        });
        if (!info || !info.successed) {
          this.$Message.warning(info.msg,50);
          return;
        }
      }
      if (e === 0) {
        this.loading = true;
      } else {
        this.loading2 = true;
      }
      let body = {
        "ExhibitionId":this.exhibitonId,
        "JoinId":this.joinInfo.joinId,
        "DeExCardDown": {
          "JoinId":this.joinInfo.joinId,
          "BadgeType": "展商证",
          "CompanyName": form.CompanyName,
          "FirstName": form.FirstName,
          "JobTitle": form.JobTitle,
          "Tel": form.Tel,
          "Email": form.Email,
          "Idcard": form.IdCard,
        }
      }
      this.$http.post('/api/DeExCardDown',body,this.header)
        .then( res =>{
         if(res.status === 200 && res.data.successed){
           this.$Message.success("success");
           if (e === 0) {
            this.loading = false;
            this.$refs["formInline"].resetFields();
            this.formInline.CompanyName = "";
            this.formInline.FirstName = "";
            this.formInline.JobTitle = "";
            this.formInline.Tel = "";
            this.formInline.Email = "";
            this.formInline.IdCard = "";
           } else {
            this.loading2 = false;
            this.$emit('addFinsh');
            this.cancel();
           }
         }else{
           if (e === 0) {
             this.loading = false;
           } else {
             this.loading2 = false;
           }
           this.$Message.error("fail,please try again");
         }
        })
    },
    validForm(name) {
      // 验证表单
      return new Promise((resolve, reject) => {
        this.$refs[name].validate(valid => {
          resolve(valid);
        });
      });
    },
    cancel() {
      this.$refs["formInline"].resetFields();
      this.formInline.CompanyName = "";
      this.formInline.FirstName = "";
      this.formInline.JobTitle = "";
      this.formInline.Tel = "";
      this.formInline.Email = "";
      this.formInline.IdCard = "";
      this.$emit("close");
    },
    changeCheck(e){
      this.check=e
      // if (this.check==true){
      //   let reg=[/\d{9}/,/^\d{6,10}$/, /[a-zA-Z]{2}[0-9]{6}/, /[0-9]{2}[a-zA-Z]{2}[0-9]{5}/, /[a-zA-Z]{2}[0-9]{7}/, /[a-zA-Z]{3}[0-9]{6}/, /[a-zA-Z][a-zA-Z0-9]{7}[a-zA-Z]/,/[a-zA-Z]{1}[0-9]{8}/];
      //   this.verification1 =false
      //
      //   for(let i=0;i<reg.length;i++){
      //     if (reg[i].test(this.formInline.IdCard)){
      //       this.verification1=true
      //       break;
      //     }
      //   }
      //
      // }
    }
  }
};
</script>

<style scoped lang="scss">
.admin-add {
  &-content {
    padding: 20px 40px 20px 20px;
  }
}
.admin-add {
  &-title {
    width: 100%;
    text-align: center;
    margin-bottom: 20px;
    font-size: 16px;
  }
  &-content {
    .submit {
      display: flex;
      justify-content: center;
      button {
        margin-left: -75px;
      }
    }
    img {
      width: 150px;
      height: 150px;
    }
  }
  .form-code-item {
    position: relative;
    .form-code-btn {
      position: absolute;
      right: 1px;
      width: 96px;
      top: 2px;
      border: none;
      outline: none;
      &:focus {
        box-shadow: none;
        border: none;
        outline: none;
      }
    }
  }
}
</style>

